// extracted by mini-css-extract-plugin
module.exports = {"roomConfiguratorContainer":"styles_roomConfiguratorContainer__qpXb9"};